import { z } from "zod";
import { Color } from "../shared/colors";
import { BaseOverlayConfig } from "../shared/config";
import { defineOverlay } from "../shared/functions";
// Overlay-specific configuration
const backgroundColors = [
    Color.DEFAULT_RED,
    Color.LIGHT_PURPLE,
    Color.DARK_PURPLE,
    Color.LIGHT_BLUE,
    Color.DARK_BLUE,
    Color.LIGHT_AQUA,
    Color.LIGHT_GREEN,
    Color.DARK_GREEN,
    Color.LIGHT_YELLOW,
    Color.DARK_YELLOW,
];
const orientations = ["horizontal", "vertical"];
const alignmentOptions = ["left", "right"];
// Export the overlay
export const DonorListOverlay = defineOverlay({
    defaults: {
        alignment: "right",
        backgroundColor: Color.DEFAULT_RED,
        displayIncentives: false,
        orientation: "vertical",
        showDonors: 5,
    },
    details: {
        category: "overlays",
        description: "Utilize our donor list overlay to enhance your Tiltify fundraising campaign. Allow your viewers to see what has been happening during your fundraising campaign.",
        features: [
            "Fits well into any streaming layouts",
            "Lists recent activities to your viewers",
            "Displays when incentives have been claimed",
            "Vertical and horizontal layout options",
        ],
        flags: {
            isFeatured: false,
            isNew: false,
            isUpdated: false,
            isVisible: true,
        },
        icon: "overlays/donor-list.png",
        name: "Donor List",
        obsDimensions: [
            { height: "height to fit your list of donors", width: "500px" },
            { height: "180px", width: "1920px" },
        ],
        path: "/overlays/donorlist",
        shortDescription: "Display a list of donors on your stream",
        slug: "donorlist",
    },
    schema: BaseOverlayConfig.extend({
        alignment: z.enum(alignmentOptions).default("right").optional(),
        backgroundColor: z
            .enum(backgroundColors)
            .default(() => DonorListOverlay._config.defaults.backgroundColor)
            .optional(),
        displayIncentives: z
            .boolean()
            .default(() => DonorListOverlay._config.defaults.displayIncentives)
            .optional(),
        orientation: z
            .enum(orientations)
            .default(() => DonorListOverlay._config.defaults.orientation)
            .optional(),
        showDonors: z
            .number()
            .int()
            .min(1)
            .default(() => DonorListOverlay._config.defaults.showDonors)
            .optional(),
    }),
});
//# sourceMappingURL=donor-list.js.map